import { AppNS } from 'app';

interface LayoutTab {
  index: number;
  name: string;
  slug: string;
  disabled: boolean;
  visibleFor: ('admin' | 'agency')[];
}

export const PROFILE_TABS: LayoutTab[] = [
  {
    index: 0,
    name: 'General Info',
    slug: 'main',
    disabled: false,
    visibleFor: ['agency', 'admin'],
  },
  {
    index: 1,
    name: 'Availability',
    slug: 'availability',
    disabled: false,
    visibleFor: ['agency', 'admin'],
  },
  {
    index: 2,
    name: 'Staff Roster',
    slug: 'users',
    disabled: false,
    visibleFor: ['agency', 'admin'],
  },
  {
    index: 2,
    name: 'Add Member',
    slug: 'users/add-member',
    disabled: true,
    visibleFor: [],
  },
  {
    index: 3,
    name: 'Disciplines',
    slug: 'disciplines',
    disabled: false,
    visibleFor: ['agency', 'admin'],
  },
  {
    index: 4,
    name: 'Payout Setup',
    slug: 'payout-setup',
    disabled: false,
    visibleFor: ['agency'],
  },
  {
    index: 5,
    name: 'Metrics',
    slug: 'metrics',
    disabled: false,
    visibleFor: ['agency', 'admin'],
  },
];

export const PROFILE_TABS_TO_CHECK_INSPECTORS_PERMISSION: {
  id: (typeof PROFILE_TABS)[number]['slug'];
  permissions: AppNS.Permission[];
}[] = [{ id: 'payout-setup', permissions: ['setup_payment_information', 'manage_company_profile'] }];

export const PERFORMANCE_TABS = [
  {
    index: 0,
    name: 'Dashboard',
    slug: 'dashboard',
    disabled: false,
    visible: true,
  },
  {
    index: 1,
    name: 'Quarterly QA/QC',
    slug: 'qa-report',
    disabled: false,
    visible: true,
  },
  {
    index: 2,
    name: 'CTP Records',
    slug: 'ctp-records',
    disabled: false,
    visible: true,
  },
];

export const INVITATION_TABS = [
  {
    index: 0,
    name: 'Role and Permissions',
    slug: 'permissions',
    disabled: false,
    visible: true,
  },
  {
    index: 1,
    name: 'Certificate and Payment',
    slug: 'certificate',
    disabled: false,
    visible: true,
  },
];

export const AGENCY_STATES: { id: AppNS.CompanyState; name: string }[] = [
  { id: 'draft', name: 'Draft' },
  { id: 'pending', name: 'Pending' },
  { id: 'unpublished', name: 'Unpublished' },
  { id: 'certified', name: 'Certified' },
  { id: 'deactivated', name: 'Deactivated' },
  { id: 'suspended', name: 'Suspended' },
  { id: 'removed', name: 'Removed' },
];

export const getStateNameById = (id: AppNS.CompanyState): string => {
  return AGENCY_STATES.find((item) => item.id === id)?.name || '-';
};

export const INVITATION_STATES: { id: AppNS.InvitationState; name: string }[] = [
  { id: 'pending', name: 'Pending' },
  { id: 'accepted', name: 'Accepted' },
  { id: 'rejected', name: 'Rejected' },
  { id: 'resigned', name: 'Resigned' },
  { id: 'cancelled', name: 'Cancelled' },
];

export const getInvitationStateNameById = (id: AppNS.InvitationState): string => {
  return INVITATION_STATES.find((item) => item.id === id)?.name || '-';
};
